import React from 'react'

export default function ProfileLimit({cancel}) {
  return (
    <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
        <div className="bg-white mx-auto rounded shadow p-5 text-center">
            <h4>Important Information</h4>
            <p>
                You have exceeded your profile limit and as a result new leads will not be able to signup through public pages,
                we encourage you to upgrade your plan or purchase additional profiles in billing
            </p>

            <div className="pt-3">
                <button onClick={cancel} type="button" className="btn btn-primary mr-2">
                    Close
                </button>
            </div>
        </div>
    </div>
  )
}
